import * as echarts from "echarts";
import { formatValue } from "./utils";

export const getDonutChartOption = (section) => ({
  color: section.items.map((item) => item.color),
  animation: false,
  tooltip: {
    trigger: "item",
    confine: true,
    formatter: ({ name, value, percent }) =>
      `${name}<br/>${formatValue(value)} Cr (${percent}%)`,
    backgroundColor: "rgba(15, 23, 42, 0.92)",
    borderWidth: 0,
    textStyle: {
      color: "#f8fafc",
      fontSize: 12,
    },
  },
  series: [
    {
      type: "pie",
      radius: ["65%", "82%"],
      center: ["50%", "45%"],
      label: { show: false },
      labelLine: { show: false },
      avoidLabelOverlap: true,
      itemStyle: {
        borderRadius: 6,
        borderColor: "#fff",
        borderWidth: 1,
      },
      data: section.items.map((item) => ({
        value: Math.abs(Number(item.value || 0)),
        name: item.name,
        itemStyle: { color: item.color },
      })),
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: "rgba(0, 0, 0, 0.3)",
        },
      },
    },
  ],
  graphic: [
    {
      type: "text",
      left: "center",
      top: "38%",
      bounding: "raw",
      style: {
        text: formatValue(section.total),
        fill: "#1e293b",
        fontSize: 18,
        fontWeight: 700,
        align: "center",
        verticalAlign: "middle",
      },
    },
    {
      type: "text",
      left: "center",
      top: "54%",
      bounding: "raw",
      style: {
        text: section.centerLabel,
        fill: "#94a3b8",
        fontSize: 12,
        fontWeight: 700,
        align: "center",
        verticalAlign: "middle",
      },
    },
  ],
});

export const getTrendChartOption = ({ labels, factory, onshore, service }) => ({
  animation: false,
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "line",
      lineStyle: {
        color: "#cbd5e1",
        type: "dashed",
      },
    },
    backgroundColor: "rgba(15, 23, 42, 0.92)",
    borderWidth: 0,
    textStyle: {
      color: "#f8fafc",
      fontSize: 12,
    },
  },
  grid: {
    left: 42,
    right: 18,
    top: 24,
    bottom: 42,
  },
  xAxis: {
    type: "category",
    boundaryGap: false,
    data: labels,
    axisLine: {
      lineStyle: {
        color: "#dbe4f5",
      },
    },
    axisTick: { show: false },
    axisLabel: {
      fontSize: 12,
      fontWeight: "bold",
      color: "#000",
      margin: 14,
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: "#eef2ff",
      },
    },
  },
  yAxis: {
    type: "value",
    axisLine: { show: false },
    axisTick: { show: false },
    axisLabel: {
      fontSize: 12,
      fontWeight: "bold",
      color: "#000",
    },
    splitLine: {
      lineStyle: {
        color: "#e6ecfb",
      },
    },
  },
  series: [
    {
      name: "Factory",
      type: "line",
      data: factory,
      z: 1,
      lineStyle: {
        color: "#4361ee",
        width: 2.5,
      },
      areaStyle: {
        color:  new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: "rgba(67,97,238,0.35)" },
          { offset: 1, color: "rgba(67,97,238,0.08)" },
        ]),
      },
    },
    {
      name: "Onshore",
      type: "line",
      data: onshore,
      z: 3,
      lineStyle: {
        color: "#2a9d90",
        width: 2.5,
      },
      areaStyle: {
        color:  new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: "rgba(42,157,144,0.35)" },
          { offset: 1, color: "rgba(42,157,144,0.08)" },
        ]),
      },
    },
    {
      name: "Service",
      type: "line",
      data: service,
      z: 2,
      lineStyle: {
        color: "#6d4cf5",
        width: 2.5,
      },
      areaStyle: {
        color:  new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: "rgba(109,76,245,0.35)" },
          { offset: 1, color: "rgba(109,76,245,0.08)" },
        ]),
      },
    },
  ],
});
